import { required, numeric, between } from 'vuelidate/lib/validators'

const ValidationsMixin = {
  provide () {
    // Dependency injection: provide/inject
    return { $v: this.$v }
  },
  data () {
    return {
      editOpportunity: {
        opportunityDetailsTab: {
          typeId: '',
          brandId: '',
          opportunityName: '',
          referenceNumber: '',
          departureDate: '',
          regionId: '',
          ownerId: '',
          ownerName: '',
        },
        clientInformationTab: {
          typeId: '',
          accountName: '',
          email: '',
          phoneNumber: '',
          address: '',
          contactName: ''
        },
        quoteRequestTab: {
          supplierId: '',
          stageId: '',
          hotelStandard: '',
          focPlaces: '',
          budget: '',
          priceBreak: '',
          guests: '',
          commission: '',
          arrivalAirportPort: '',
          departureAirportPort: '',
          quoteDeadline: '',
          difficultDatesChecked: false,
          flourishesLocalTreats: false,
          gratuitiesForTdDriver: false,
          tdOfferOptionals: false,
          prebookingsRequired: false,
          repeatGuestGift: false,
          includingLocalGuides: false,
          birthdayAllowance: false,
          groupPhoto: false,
          additionalInformation: '',
          additionalFileId: ''
        },
        sections: {
          letter: '',
          pricing: '',
          agentPricing: '',
          termsAndConditions: '',
          consumerTermsAndConditions: '',
          bookMyGroup: '',
          airContract: '',
        },
        consumerSection: {
          yourDetails: {
            callToAction: '',
            uploadCompanyLogo: '',
            uploadTourHostPhoto: '',
            tourHostName: '',
            tourHostPosition: ''
          },
          tripDetails: {
            tripName: '',
            tripSubtitle: '',
            companyName: '',
            twinsharePrice: '',
            singleSuppPrice: '',
            twinsharePriceName: '',
            singleSuppPriceName: '',
            shortDescription: '',
            termsAndConditions: ''
          }
        },
        guestDocumentation: {
          introduction: '',
          optionalExperience: '',
          hotelList: ''
        }
      }
    }
  },
  validations: {
    editOpportunity: {
      opportunityDetailsTab: {
        typeId: { required },
        brandId: {},
        opportunityName: {},
        referenceNumber: {},
        departureDate: {},
        regionId: { required },
        ownerId: '',
        ownerName: {},
      },
      clientInformationTab: {
        typeId: {},
        accountName: {},
        email: {},
        phoneNumber: {},
        address: {},
        contactName: {}
      },
      quoteRequestTab: {
        supplierId: {},
        stageId: {},
        hotelStandard: {},
        focPlaces: {},
        budget: {},
        priceBreak: {},
        guests: { numeric, between: between(0, 99999) },
        commission: { numeric, between: between(0, 100) },
        arrivalAirportPort: {},
        departureAirportPort: {},
        quoteDeadline: {},
        difficultDatesChecked: {},
        flourishesLocalTreats: {},
        gratuitiesForTdDriver: {},
        tdOfferOptionals: {},
        prebookingsRequired: {},
        repeatGuestGift: {},
        includingLocalGuides: {},
        birthdayAllowance: {},
        groupPhoto: {},
        additionalInformation: {},
        additionalFileId: {}
      },
      sections: {
        letter: {},
        pricing: {},
        agentPricing: {},
        termsAndConditions: {},
        consumerTermsAndConditions: {},
        bookMyGroup: {},
        airContract: {},
      },
      consumerSection: {
        yourDetails: {
          callToAction: {},
          uploadCompanyLogo: {},
          uploadTourHostPhoto: {},
          tourHostName: {},
          tourHostPosition: {}
        },
        tripDetails: {
          tripName: {},
          tripSubtitle: {},
          companyName: {},
          twinsharePrice: {},
          singleSuppPrice: {},
          twinsharePriceName: {},
          singleSuppPriceName: {},
          shortDescription: {},
          termsAndConditions: {}
        }
      },
      guestDocumentation: {
        introduction: {},
        optionalExperience: {},
        hotelList: {}
      }
    }
  }
}

export default ValidationsMixin
